import React from 'react'
import Pill from '@components/V3/Pill'
import {useTranslation} from 'next-i18next'

import useOrderDetails from './useOrderDetails.main'

export default function Invoice() {
  const order = useOrderDetails()
  const {t} = useTranslation('tracking', {keyPrefix: 'order.inner'})
  if (!order.saleInvoice?.fileURL) return null

  return (
    <div className="flex mt-1 justify-end">
      <Pill small showCaret={false}>
        <a
          className="text-gray-700 dark:text-gray-200"
          target="_blank"
          rel="noopener noreferrer"
          href={order.saleInvoice.fileURL}>
          {t('viewInvoice')}
        </a>
      </Pill>
    </div>
  )
}
